import { Link } from "react-router-dom";
import { CheckCircle2, Circle } from "lucide-react";
import { C } from "./constants";

const Tag = ({ children }) => (
  <span className="shrink-0 rounded px-1.5 py-0.5 text-[10px] font-bold" style={{ background: C.mint, color: C.green }}>{children}</span>
);

const ActionRow = ({ done, text, tag }) => (
  <li className="flex items-start gap-2 rounded-lg bg-white p-3 text-sm" style={{ color: C.text }}>
    {done ? <CheckCircle2 className="w-4 h-4 mt-0.5 shrink-0" style={{ color: C.green }} /> : <Circle className="w-4 h-4 mt-0.5 shrink-0 text-slate-400" />}
    <span className="flex-1">{text}</span>
    <Tag>{tag}</Tag>
  </li>
);

const Capa1Item = ({ top, testId }) => (
  <div data-testid="tablero-closing-capa1">
    <p className="text-[15px]" style={{ color: C.text }}>
      <span className="text-[11px] font-bold uppercase tracking-[0.14em] mr-2" style={{ color: C.gold }}>Capa 1</span>
      <span className="font-bold">{top.nombre}</span> · {top.zona}
    </p>
    <ul className="mt-2 space-y-2">
      <ActionRow done={top.action?.done} text={top.texto} tag="Desde el tablero · 30 días" />
    </ul>
    <Link to={`/consulting/${testId}/checklist?area=G`} className="inline-block mt-2 text-[13px] font-semibold underline" style={{ color: C.green }} data-testid="tablero-closing-capa1-checklist">Ver en la checklist</Link>
  </div>
);

const Capa2Item = ({ top, testId }) => (
  <div data-testid="tablero-closing-capa2">
    <p className="text-[15px]" style={{ color: C.text }}>
      <span className="text-[11px] font-bold uppercase tracking-[0.14em] mr-2" style={{ color: C.gold }}>Capa 2</span>
      <span className="font-bold">{top.nombre}</span> · {top.zona}
    </p>
    <ul className="mt-2 space-y-2">
      <ActionRow done={top.action?.done} text={top.texto} tag="Desde el tablero · 30 días" />
    </ul>
    <Link to={`/consulting/${testId}/checklist?area=G`} className="inline-block mt-2 text-[13px] font-semibold underline" style={{ color: C.green }} data-testid="tablero-closing-capa2-checklist">Ver en la checklist</Link>
  </div>
);

const Capa3Item = ({ top, testId }) => (
  <div data-testid="tablero-closing-capa3">
    <p className="text-[15px]" style={{ color: C.text }}>
      <span className="text-[11px] font-bold uppercase tracking-[0.14em] mr-2" style={{ color: C.gold }}>Capa 3</span>
      <span className="font-bold" data-testid="tablero-closing-area">{top.nombre}</span> · {top.zona}
    </p>
    {top.actions.length > 0 ? (
      <ul className="mt-2 space-y-2" data-testid="tablero-closing-actions">
        {top.actions.map((a) => <ActionRow key={a.id} done={a.done} text={a.accion} tag="Prioridad del tablero" />)}
      </ul>
    ) : (
      <p className="mt-2 text-sm" style={{ color: "#5B6B64" }}>Esta área no tiene acciones de 30 días en tu checklist.</p>
    )}
    <div className="mt-3 flex flex-wrap gap-2">
      {top.tools.map((t) => (
        <Link key={t.key} to={`/consulting/${testId}/tools/${t.key}`} className="rounded-full px-4 py-2 text-[13px] font-semibold text-white" style={{ background: C.green }} data-testid={`tablero-closing-tool-${t.key}`}>{t.title}</Link>
      ))}
      <Link to={`/consulting/${testId}/checklist?area=${top.area}`} className="rounded-full px-4 py-2 text-[13px] font-semibold border bg-white" style={{ color: C.green, borderColor: C.green }} data-testid="tablero-closing-checklist">Ver en la checklist</Link>
    </div>
  </div>
);

const title = (n) => (n === 3 ? "Tus 3 decisiones para los próximos 90 días" : n === 2 ? "Tus decisiones para los próximos 90 días" : "Tu prioridad para los próximos 90 días");

export const ClosingBlock = ({ capa1Top, capa2Top, capa3Top, testId }) => (
  <section className="rounded-2xl p-6 md:p-8 border space-y-5" style={{ background: C.cream, borderColor: C.green }} data-testid="tablero-closing">
    <div>
      <div className="text-[10px] font-bold uppercase tracking-[0.22em] mb-2" style={{ color: C.gold }}>Cierre</div>
      <h2 className="font-display text-xl md:text-2xl font-bold" style={{ color: C.text }} data-testid="tablero-closing-title">
        {title([capa1Top, capa2Top, capa3Top].filter(Boolean).length)}
      </h2>
    </div>
    {capa1Top && <Capa1Item top={capa1Top} testId={testId} />}
    {capa2Top && <Capa2Item top={capa2Top} testId={testId} />}
    {capa3Top && <Capa3Item top={capa3Top} testId={testId} />}
  </section>
);
